import React from "react";
import { Header } from "@/components/header/header";

interface LayoutProps {}

export const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = ({
  children,
}) => {
  return (
    <>
      <Header />
      <div className="wrapper w-full bg-main-mobile md:bg-main bg-cover bg-no-repeat dark:bg-dark-bg relative">
        <div className="fixed top-4 right-[-34px] z-50 pointer-events-none rotate-45 bg-violet-600 px-10 py-1 shadow-lg">
          <span className="font-sf-pro text-xs font-semibold tracking-wide text-white">
            BETA
          </span>
        </div>
        {children}
      </div>
    </>
  );
};
